module.exports = __webpack_public_path__ + "static/media/office_word.8655f0f6.svg";